import script from "./DonationPrivacyPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./DonationPrivacyPolicy.vue?vue&type=script&setup=true&lang=js"

import "./DonationPrivacyPolicy.vue?vue&type=style&index=0&id=36044f84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36044f84"]])

export default __exports__